import React, { useEffect, useRef, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Radio, RadioGroup, FormControlLabel, FormLabel, FormHelperText, Autocomplete
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { QuotationMaster } from '../TitleList';
import styled, { inputImages, inputStyles, inputNumber, inputNumbers } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { useNavigate } from 'react-router-dom';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchSchoolData } from '../../Store/PHPSlice/School';
import { selectCloths, selectFirm, selectItemAvg, selectItems, selectJobRate, selectParty, selectPriPerGrp, selectQuotationNo, selectQuotNo, selectSchool } from '../Selectors/Master/ItemSelectors';
import { fetchPricePerData } from '../../Store/PHPSlice/Sale/PricePercent';
import { createQuotationEntry, fetchQuotationNo, fetchQuotNo } from '../../Store/PHPSlice/Sale/Quotation';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { useNavigation } from '../NavigationContext';
import { fetchJobRateData } from '../../Store/PHPSlice/JobRate';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import PreviewIcon from '@mui/icons-material/Preview';
import { errorStyles } from '../../Utils/table';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

const QuotationEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        firm: '',
        quotType: '0',
        quotNo: '',
        quotationNo: '',
        partyId: '',
        priceList: '',
        item: '',
        schl: '',
        jobrate: '',
        extra: '0',
        outSrc: '0',
        naration: '-',
        size: '',
        match: '',
        profit: '0',
        loss: '0',
        chpricelist: 0,
        userId: userdata?.ID
    });
    const [formArray, setFormArray] = useState([]);
    const [formCopy, setFormCopy] = useState({
        firmNm: '',
        partyNm: '',
        priceNm: '',
        itemNm: '',
        schlNm: '',
        mrp: '',
        firm: ''
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        schl: fetchSchoolData,
        item: fetchItemData,
        partyId: fetchPartyData,
        cloth: fetchClothData
        // Add more mappings if needed
    };
    const [errors, setErrors] = useState({});
    const [clothdata, setClothdata] = useState([]);
    const [m1clothdata, setM1Clothdata] = useState([]);
    const [m2clothdata, setM2Clothdata] = useState([]);
    const [m3clothdata, setM3Clothdata] = useState([]);
    const [matching, setMatching] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [priceListType, setPriceListType] = useState('');
    const [priceClothList, setPriceClothList] = useState([]);
    const [priceCloth, setPriceCloth] = useState('');
    const [priceListRates, setPriceListRates] = useState([]);
    const clothTypes = ['Main Cloth', 'Matching Cloth-1', 'Matching Cloth-2', 'Matching Cloth-3'];
    const [rows, setRows] = useState([
        { clothTypes: 'Main Cloth', cloth: '0', rate: '0', panna: '0' }
    ]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const quotationNoRef = useRef(null);
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const itemlist = useSelector(selectItems);
    const schlList = useSelector(selectSchool);
    const pricelist = useSelector(selectPriPerGrp);
    const quotNo = useSelector(selectQuotNo);
    const quotationNo = useSelector(selectQuotationNo);
    const clothlist = useSelector(selectCloths);
    const jobratelist = useSelector(selectJobRate);
    const itemAvglist = useSelector(selectItemAvg);
    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchItemData());
        dispatch(fetchSchoolData());
        dispatch(fetchPricePerData());
        dispatch(fetchQuotNo());
        dispatch(fetchQuotationNo());
        dispatch(fetchClothData());
        dispatch(fetchJobRateData());
        dispatch(fetchItemAvgData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [dispatch, openDropdowns]);

    // useEffect(() => {
    //     if (quotNo.data) {
    //         const val = quotNo?.data?.quotNo;
    //         setFormData(prevData => ({
    //             ...prevData,
    //             quotNo: val
    //         }))
    //     }
    //     if (quotationNo.data) {
    //         const item = quotationNo?.data?.quotationNo;
    //         setFormData(prevFormData => ({
    //             ...prevFormData,
    //             quotationNo: item
    //         }))
    //     }
    // }, [quotNo, quotationNo]);

    useEffect(() => {
        if (formData.quotNo === '' && quotNo?.data?.quotNo) {
            const val = quotNo.data.quotNo;

            setFormData(prevData => ({
                ...prevData,
                quotNo: val
            }));
        }

        if (quotationNo?.data?.quotationNo) {
            const item = quotationNo.data.quotationNo;

            setFormData(prev => ({
                ...prev,
                quotationNo: item
            }));
        }

    }, [quotNo, quotationNo]);


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const handleNavitoItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleNavitoParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleNavitoSchool = () => {
        window.open(`/NewSchoolEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleNavitoCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // setPreviousPath(window.location.pathname);
        // navigate('/NewClothEntry');
    };

    const checkItempricelist = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=checkItemPricelistInquotationentry&itemId=${id}`);
            const data = res.data?.data;
            return data;
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;

        const updateFormData = (updates) => {
            setFormData(prev => ({
                ...prev,
                ...updates
            }));
        };

        const updateFormCopy = (key, value) => {
            setFormCopy(prev => ({
                ...prev,
                [key]: value
            }));
        };

        switch (dropdownType) {
            case 'item':
                if (value) {
                    // const selectJobRate = jobratelist.data.find(val => val.itemId === value);
                    const checkitempricelistcount = await checkItempricelist(value);
                    if (checkitempricelistcount?.id > 0) {
                        // console.log(checkitempricelistcount);
                        setFormData(prev => ({
                            ...prev,
                            chpricelist: checkitempricelistcount?.id
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            chpricelist: 0
                        }));
                        setPriceListRates([]);

                    }
                    const selectJobRate = jobratelist?.data?.find?.(val => val.itemId === value) || '';
                    const selectedSize = itemlist?.data?.find(val => val.ID === value);

                    updateFormCopy('itemNm', selectedSize.itemNm);

                    const updates = selectJobRate ? {
                        jobrate: selectJobRate.total,
                        size: selectedSize.size
                    } : {
                        jobrate: '',
                        size: selectedSize.size
                    };

                    updateFormData({
                        ...updates,
                        item: selectJobRate ? value : ''
                    });

                    // if (!selectJobRate) {
                    //     alert('For this Item Job Rate is not Defined');
                    // }
                    // Filter and process average values
                    const selectPanna = itemAvglist?.data?.filter(val => val.itemId === value);
                    // console.log(selectPanna);
                    if (selectPanna?.length > 0) {
                        const selectAvg = selectPanna?.filter(val => val.avg !== '0');
                        const selectm1Avg = selectPanna?.filter(val => val.avg1 !== '0');
                        const selectm2Avg = selectPanna?.filter(val => val.avg2 !== '0');
                        const selectm3Avg = selectPanna?.filter(val => val.avg3 !== '0');

                        // Determine unique sizes
                        const uniquePannasizes = [...new Set(selectAvg?.map(val => val.panna_size))];
                        const uniqueM1Pannasizes = [...new Set(selectm1Avg?.map(val => val.panna_size))];
                        const uniqueM2Pannasizes = [...new Set(selectm2Avg?.map(val => val.panna_size))];
                        const uniqueM3Pannasizes = [...new Set(selectm3Avg?.map(val => val.panna_size))];

                        // Filter cloth data based on sizes
                        const filterCloth = clothlist?.data?.filter(val => uniquePannasizes?.includes(val.panna_size));
                        const filterM1Cloth = clothlist?.data?.filter(val => uniqueM1Pannasizes?.includes(val.panna_size));
                        const filterM2Cloth = clothlist?.data?.filter(val => uniqueM2Pannasizes?.includes(val.panna_size));
                        const filterM3Cloth = clothlist?.data?.filter(val => uniqueM3Pannasizes?.includes(val.panna_size));

                        // Update cloth data
                        setClothdata(filterCloth);
                        setM1Clothdata(filterM1Cloth);
                        setM2Clothdata(filterM2Cloth);
                        setM3Clothdata(filterM3Cloth);

                        // Update matching options
                        const newMatching = [];
                        if (filterM1Cloth.length > 0) newMatching.push({ label: 'Matching 1', value: '1' });
                        if (filterM2Cloth.length > 0) newMatching.push({ label: 'Matching 2', value: '2' });
                        if (filterM3Cloth.length > 0) newMatching.push({ label: 'Matching 3', value: '3' });

                        // Set matching state
                        setMatching(newMatching);
                    } else {
                        // alert('Average value for this item is not set.');
                        const res = window.confirm('Average value for this item is not set.');
                        if (res) {
                            window.open(`/new-item-avg-entry`, '_blank', 'width=1000,height=1000,scrollbars=yes,resizable=yes');
                        }
                    }
                }
                break;

            case 'match':
                const selectedValue = parseInt(value, 10);
                updateRows(selectedValue);
                break;

            case 'priceList':
                if (pricelist?.data?.length > 0) {
                    const selectPrice = pricelist?.data?.find(val => val.ID === value);
                    if (selectPrice) {
                        updateFormCopy('priceNm', selectPrice?.grpNm);
                        updateFormCopy('firm', selectPrice?.firmPer);
                        updateFormCopy('mrp', selectPrice?.mrpPer);
                    }
                }
                break;

            case 'partyId':
                if (partylist?.data?.length > 0) {
                    const selectParty = partylist?.data?.find(val => val.ID === value);
                    if (selectParty) {
                        updateFormCopy('partyNm', selectParty?.partyNm);
                    }
                }
                break;

            case 'firm':
                if (firmlist?.data?.length > 0) {
                    const selectfirm = firmlist?.data?.find(val => val.ID === value);
                    if (selectfirm) {
                        updateFormCopy('firmNm', selectfirm?.firmNm);
                    }
                }
                break;

            case 'schl':
                if (schlList?.data?.length > 0) {
                    const selectSchool = schlList?.data?.find(val => val.ID === value);
                    if (selectSchool) {
                        updateFormCopy('schlNm', selectSchool?.schoolNm);
                    }
                }
                break;

            default:
                break;
        }

        // Update form data with the selected dropdown value
        updateFormData({ [dropdownType]: value });
    };

    const updateRows = (matchCount) => {
        const newRows = clothTypes.slice(0, matchCount + 1).map(type => ({
            clothTypes: type,
            cloth: '',
            rate: '0',
            panna: '0',
        }));
        setRows(newRows);
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));

        if (name === 'extra' && priceListRates.length > 0) {
            const extraValue = value === "" ? "" : Number(value);

            setPriceListRates(prevRates =>
                prevRates.map(item => {
                    // ✅ Proper fallback
                    const base =
                        item.baseRate !== undefined
                            ? Number(item.baseRate)
                            : Number(item.rate);

                    return {
                        ...item,
                        baseRate: base, // store once
                        rate: extraValue === ""
                            ? base
                            : base + extraValue
                    };
                })
            );
        }
    };


    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        if (name === 'quotType' && value === '1') {
            setFormData(prev => ({
                ...prev,
                quotationNo: ''
            }));
        } else {
            if (quotationNo.data) {
                const item = quotationNo.data.quotationNo;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    quotationNo: item
                }))
            }
        }
    };

    const handleDropdownChanged = (event, value, index, fieldName) => {
        // If fieldName is 'cloth', find the rate from clothlist
        if (fieldName === 'cloth' && value) {
            // Find the selected cloth in clothlist
            const selectedCloth = clothlist.data.find(cloth => cloth.ID === value.ID); // value is the selected object
            // Get the rate and panna size for the selected cloth
            const rate = selectedCloth ? selectedCloth.rate : 0;
            const panna = selectedCloth ? selectedCloth.panna_size : 0;

            const updatedRows = rows.map((row, i) =>
                i === index ? { ...row, [fieldName]: value.ID, rate, panna } : row
            );
            setRows(updatedRows);
        } else {
            // Handle other field names if necessary
            const updatedRows = rows.map((row, i) =>
                i === index ? { ...row, [fieldName]: value } : row
            );
            setRows(updatedRows); // Update rows state
        }
    };

    const handleInputChanged = (event, index) => {
        const { value, name } = event.target;
        // Update the row data based on index and name (e.g., 'rate')
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [name]: value } : row
        );
        setRows(updatedRows); // Assume setRows updates your rows state
    };

    const handleAdd = () => {
        console.log(clothTypes);
        if (!formData.firm || formData.firm.trim() === "") {
            alert("Select Firm");
        } else if (!formData.partyId || formData.partyId.trim() === "") {
            alert("Select Party");
        } else if (!formData.item || formData.item.trim() === "") {
            alert("Select Item");
        } else if ((rows.length > 0 && (!rows[0].cloth || rows[0].cloth === "0"))) {
            alert("Select Main Cloth");
        }
        else if (priceListRates.length === 0 && (!formData.jobrate || formData.jobrate.trim() === "")) {
            alert("Enter Jobrate");
        } else {
            // Convert form data and array into one object
            const newEntry = convertIntoOneObject(rows, formData, formCopy, clothlist, priceListRates, priceCloth, priceListType);
            if (newEntry !== undefined) {
                // Add the converted object to formArray
                setFormArray((prevArray) => [...prevArray, newEntry]);
                // Reset form data after adding
                setFormData(prev => ({
                    ...prev,
                    quotType: '0',
                    priceList: '',
                    item: '',
                    jobrate: '',
                    extra: '0',
                    outSrc: '0',
                    naration: '-',
                    match: '',
                    profit: '',
                    loss: ''
                }));
                // Reset rows to default values
                setRows([{
                    clothTypes: 'Main Cloth',
                    cloth: '',
                    rate: '0',
                    panna: '0'
                }]);

                setPriceCloth('');
                setPriceListType([]);
                setPriceListRates([]);
            }
        }


    };

    // const handleViewClick = (form) => {
    //     // Navigate to the details page and pass the specific row data
    //     navigate('/CuttingManuallyEntry', { state: { form } });
    // };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    const handleRemoveSelected = () => {
        setFormArray(prevFormArray =>
            prevFormArray.filter((_, index) => !selectedRows.has(index))
        );
        setSelectedRows(new Set()); // Clear selection after removal
    };


    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/QuotationView?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    function convertIntoOneObject(array, formData, formCopy, clothlist, priceListRates, priceCloth, priceListType) {
        if (!array || array.length === 0) {
            console.error("Array is missing or empty:", array);
            return null; // Return null or handle the error appropriately
        }

        const main_Avgs = array.map((_, index) => {
            return itemAvglist?.data?.filter((val) => val.itemId === formData.item && val.panna_size === (array[index]?.panna || '')) || [];
        });

        // Initialize tableData with formData fields
        const tableData = {
            dt: formData.dt || '',
            priceList: formData.priceList || '',
            item: formData.item || '',
            schl: formData.schl || '',
            jobrate: formData.jobrate || '',
            extra: formData.extra || '',
            outSrc: formData.outSrc || '',
            nar: formData.naration || '',
            size: formData.size?.split(',') || '',
            userId: formData.userId || '',
            firmNm: formCopy.firmNm || '',
            partyNm: formCopy.partyNm || '',
            priceNm: formCopy.priceNm || '',
            itemNm: formCopy.itemNm || '',
            schlNm: formCopy.schlNm || '',
            firmPer: formCopy.firm || '',
            mrp: formCopy.mrp || '',
            profit: formData.profit || 0,
            loss: formData.loss || 0,
            priceListRates: priceListRates,
            priceCloth: priceCloth,
            priceListType: priceCloth ? priceListType : '0'
        };

        // Helper function to get clothNm by cloth ID
        const getClothNmById = (clothId) => {
            const cloth = clothlist.data.find(cloth => cloth.ID === clothId);
            return cloth ? `${cloth.clothNm} ${cloth.model} ${cloth.color} ${cloth.shadeNo}` : '';
        };

        // Iterate over each array element and populate tableData
        for (let index = 0; index < array.length; index++) {
            const item = array[index];
            const clothValue = item.cloth || 0;
            const rateValue = item.rate || 0;

            // Check for invalid values in cloth and rate fields
            if (priceListRates.length === 0) {
                if ((clothValue === '0' || rateValue === '0') || rateValue === " ") {
                    if (index === 0) {
                        alert('Enter main cloth rate');
                    } else {
                        alert(`Enter Matching-${index} cloth rate`);
                    }
                    return; // Exit the function early if invalid data is found
                }
            }

            tableData[`m${index}`] = clothValue;
            tableData[`m${index}rate`] = rateValue;
            tableData[`m${index}_panna`] = item.panna || 0;
            tableData[`m${index}clothNm`] = getClothNmById(item.cloth); // Lookup clothNm

            const main_Avg = main_Avgs[index];
            // console.log(main_Avg);

            tableData[`m${index}_avg`] = main_Avg.map((val) => ({
                avg: val.avg,
                size: val.size
            })) || [];
            tableData[`m${index}_avg1`] = main_Avg.map((val) => ({
                avg1: val.avg1,
                size: val.size
            })) || [];
            tableData[`m${index}_avg2`] = main_Avg.map((val) => ({
                avg2: val.avg2,
                size: val.size
            })) || [];
            tableData[`m${index}_avg3`] = main_Avg.map((val) => ({
                avg3: val.avg3,
                size: val.size
            })) || [];
        }

        return tableData;
    };


    function conintoObject2(formData, formArray) {
        const data = {
            quotNo: formData.quotNo,
            quotType: formData.quotType,
            quotationNo: formData.quotationNo,
            dt: formData.dt,
            firm: formData.firm,
            partyId: formData.partyId,
            userId: formData.userId,
            itemData: formArray
        };
        return data;
    }

    const validate = () => {
        const newErrors = {};
        if (!formData.firm) newErrors.firm = 'Firm Name is required';
        if (!formData.partyId) newErrors.partyId = 'Party Name is required';
        return newErrors;
    };

    const getFilteredClothData = (clothType) => {
        switch (clothType) {
            case 'Main Cloth':
                return clothdata;
            case 'Matching Cloth-1':
                return m1clothdata;
            case 'Matching Cloth-2':
                return m2clothdata;
            case 'Matching Cloth-3':
                return m3clothdata;
            default:
                return [];
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);

        try {

            const finalObj = conintoObject2(formData, formArray);
            console.log(finalObj)

            const result = await dispatch(createQuotationEntry(finalObj)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Quotation Added");
            alert("Quotation Added");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleNavigateItemAvg = () => {
        window.open(`/new-item-avg-entry`, '_blank', 'width=1000,height=1000,scrollbars=yes,resizable=yes');
    };

    const handlePriceClothChange = async (e) => {
        const cloth = e.target.value;
        setPriceCloth(cloth);
        setPriceListRates([]);

        if (!cloth || !priceListType || !formData.item) return;

        try {
            const res = await fetch(
                `${baseUrl}?apicall=getPriceListRates&type=${priceListType}&clothName=${cloth}&itemId=${formData.item}`
            );

            const result = await res.json();
            // console.log("pricelist=>", result);

            // ✅ SAFETY CHECK
            const priceList = Array.isArray(result?.data)
                ? result.data
                : [];

            // convert to size-wise format
            const sizeWiseRates = priceList.map(r => ({
                size: r.size,
                rate: r.rate,
                baseRate: r.rate
            }));

            // ✅ set pricelist rates
            setPriceListRates(sizeWiseRates);

            // clear quotation rates
            // setQuotationRates([]);

            // update table data
            // setItemData(prev => ({
            //     ...prev,
            //     avgs: sizeWiseRates
            // }));
        } catch (err) {
            console.error("PriceList rate error", err);
        }
    };
    // console.log(priceListRates)

    const handlePriceListTypeChange = (e) => {
        const value = e.target.value;
        const quotId = formData.quotNo || 0;

        if (!quotId) {
            alert("Please select quotation first");
            return;
        }

        setPriceListType(value);
        setPriceCloth('');
        setPriceClothList([]);
        setPriceListRates([]);

        fetchPriceClothList(value, formData.item);
    };

    const fetchPriceClothList = async (type, itemId) => {
        try {
            //alert("hi");
            //alert("tyoe"+type);
            //alert("q=>"+quotId);
            if (!type || !itemId) return;

            const res = await fetch(
                `${baseUrl}?apicall=getPriceListCloth&type=${type}&itemId=${itemId}`
            );

            const result = await res.json();
            // console.log("result=>", result);

            // 👇 data is array of { cloth_name }
            setPriceClothList(result?.data || []);
        } catch (err) {
            console.error(err);
            setPriceClothList([]);
        }
    };

    const handleExtraChange = (index, value) => {
        setPriceListRates(prevRates =>
            prevRates.map((item, i) =>
                i === index
                    ? { ...item, rate: value === "" ? "" : Number(value) }
                    : item
            )
        );
    };

    return (
        <>
            <Titlebar data={QuotationMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Quotation Entry</h2>
                <Grid container>
                    <Grid item>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {/* { label: 'Quot. No', name: 'quotNo', type: 'readOnly' }, */}
                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <FormLabel component="legend">Quot.ItemNo.Type:</FormLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl component="fieldset" fullWidth>
                                                <RadioGroup row name="quotType" value={formData.quotType} onChange={handleRadioChange}>
                                                    <FormControlLabel value="0" control={<Radio />} label="Auto" />
                                                    <FormControlLabel value="1" control={<Radio />} label="Manual" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[
                                    { label: 'Quotation No', name: 'quotNo' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: formData.quotType === '0' }}
                                                        sx={inputStyles}
                                                        inputRef={quotationNoRef}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                            <InputLabel id="firm">Firm:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="firm"
                                                    options={firmlist?.data}
                                                    getOptionLabel={(option) => option.firmNm || ''} // Ensure this returns the correct label
                                                    value={firmlist?.data?.find(firm => firm.ID === formData.firm) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {errors.firm && <FormHelperText style={errorStyles}>{errors.firm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                            <InputLabel id="partyId">Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="partyId"
                                                    options={partylist?.data2}
                                                    getOptionLabel={(option) => option.partyNm || ''} // Ensure this returns the correct label
                                                    value={partylist?.data2?.find(party => party.ID === formData.partyId) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId')}
                                                    onOpen={() => handleDropdownOpen('party')}
                                                    onClose={() => handleDropdownClose('party')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {errors.partyId && <FormHelperText style={errorStyles}>{errors.partyId}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoParty} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Price List */}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                            <InputLabel id="priceList">Price List:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="priceList"
                                                    options={pricelist.data}
                                                    getOptionLabel={(option) => option.grpNm || ''} // Ensure this returns the correct label
                                                    value={pricelist.data.find(price => price.ID === formData.priceList) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'priceList', value: newValue ? newValue.ID : '' } }, 'priceList')}

                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {errors.priceList && <FormHelperText style={errorStyles}>{errors.priceList}</FormHelperText>}
                                            </FormControl>
                                        </Grid>

                                    </Grid>
                                </Grid> */}

                                {/* Price List */}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                            <InputLabel id="schl">School:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="schl"
                                                    options={schlList.data}
                                                    getOptionLabel={(option) => option.schoolNm || ''} // Ensure this returns the correct label
                                                    value={schlList.data.find(schl => schl.ID === formData.schl) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'schl', value: newValue ? newValue.ID : '' } }, 'schl')}
                                                    onOpen={() => handleDropdownOpen('schl')}
                                                    onClose={() => handleDropdownClose('schl')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* {errors.schl && <FormHelperText style={errorStyles}>{errors.schl}</FormHelperText>} */}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoSchool} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                            <InputLabel id="item">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="item"
                                                    options={itemlist.data}
                                                    getOptionLabel={(option) => option.itemNm || ''} // Ensure this returns the correct label
                                                    value={itemlist.data.find(item => item.ID === formData.item) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item')}
                                                    onOpen={() => handleDropdownOpen('item')}
                                                    onClose={() => handleDropdownClose('item')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* {errors.item && <FormHelperText style={errorStyles}>{errors.item}</FormHelperText>} */}

                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoItem} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* 
                                { label: 'Value of Loss%', name: 'loss' },
                                { label: 'Out Source(+)%', name: 'outSrc' },
                                */}


                                {[

                                    { label: 'Jobrate', name: 'jobrate' },
                                    { label: 'Extra', name: 'extra' },
                                    { label: 'Profit %', name: 'profit' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'Naration', name: 'naration' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        style={{ width: '80%', height: '100px', padding: '5px', borderRadius: '4px', border: '1px solid #000', ...styled.input }}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '26%' } : { width: '100%' }}>
                                            <InputLabel id="match">No of Matching:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="match"
                                                    id="match"
                                                    name="match"
                                                    value={formData.match}
                                                    onChange={(e) => handleDropdownChange(e, 'match')}
                                                    sx={inputStyles}
                                                    disabled={!formData.item}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {matching.length > 0 ? matching.map((mat, index) => (
                                                        <MenuItem key={index} value={mat.value}>{mat.label}</MenuItem>
                                                    )) : ''}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={6} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleNavigateItemAvg}>Add Item Avg.</Button>
                                </Grid>

                                <Grid item xs={12} md={8}>
                                    <TableContainer style={{
                                        width: isDesktop ? '100%' : '100%',
                                        marginLeft: isDesktop ? '20%' : '0%',
                                        overflow: 'hidden'
                                    }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth Type</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.length > 0 ?
                                                    (rows.map((row, index) => {
                                                        const filteredClothData = getFilteredClothData(row.clothTypes);
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.clothTypes}
                                                                </TableCell>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', display: 'flex', alignItems: 'center', gap: 0.4 }} align='center'>
                                                                    <Autocomplete
                                                                        id="cloth"
                                                                        options={filteredClothData}
                                                                        getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || ''}
                                                                        value={filteredClothData.find(item => item.ID === row.cloth) || null}
                                                                        onChange={(e, newValue) => handleDropdownChanged(e, newValue, index, 'cloth')} // Pass newValue as the selected object
                                                                        onOpen={() => handleDropdownOpen('cloth')}
                                                                        onClose={() => handleDropdownClose('cloth')}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                placeholder='Select Option'
                                                                                sx={{
                                                                                    ...inputStyles,
                                                                                    '& .MuiInputBase-root': {
                                                                                        height: '35px',
                                                                                    },
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={handleNavitoCloth}
                                                                        size='small'

                                                                    >
                                                                        New
                                                                    </Button>

                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <TextField
                                                                        name='rate'
                                                                        value={row.rate}
                                                                        onChange={(e) => handleInputChanged(e, index)}
                                                                        inputProps={{ style: styled.inputs }}
                                                                        sx={inputNumbers}
                                                                    />

                                                                </TableCell>

                                                            </TableRow>
                                                        )
                                                    }
                                                    )) : ''}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>

                                {formData.chpricelist > 0 &&
                                    <>

                                        {/* PRICE LIST - below Order No */}
                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item xs={3}>
                                                    <InputLabel>Price List : </InputLabel>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <FormControl fullWidth size="small">
                                                        <Select
                                                            value={priceListType}
                                                            onChange={handlePriceListTypeChange}
                                                            displayEmpty
                                                            style={{ width: '240px' }}
                                                        >
                                                            <MenuItem value="">Select</MenuItem>
                                                            <MenuItem value="MU">MU</MenuItem>
                                                            <MenuItem value="S">S</MenuItem>
                                                            <MenuItem value="N">N</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* CLOTH NAME - below Total Qty */}
                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item xs={3}>
                                                    <InputLabel>PriceList Cloth Name</InputLabel>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <FormControl fullWidth size="small" disabled={!priceListType || priceClothList.length === 0}>
                                                        <Select
                                                            value={priceCloth}
                                                            onChange={handlePriceClothChange}
                                                            displayEmpty
                                                            style={{ width: '240px' }}
                                                        >

                                                            <MenuItem value="">Select</MenuItem>
                                                            {priceClothList.map((row, index) => (
                                                                <MenuItem key={index} value={row.cloth_name}>
                                                                    {row.cloth_name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>}


                                {priceListRates.length > 0 &&
                                    <Grid item xs={12} md={12}>
                                        {/* <h3 style={{ marginTop: '10px' }}>Sale Order Details</h3> */}
                                        <TableContainer style={{ display: 'flex' }}>
                                            {/* <Table style={{ width: '60%' }}>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Particulars</TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    {itemData.data.length > 0 && itemData.data.map((item) => (
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            {item.itemNm}<br />{item.clothNm}<br /> {item.m1cloth !== '0' && item.m1cloth}<br />
                                                            &nbsp;{item.m2cloth !== '0' && item.m2cloth}<br /> {item.m3cloth !== '0' && item.m3cloth}</TableCell>
                                                    ))}
                                                </TableRow>

                                            </TableBody>
                                        </Table> */}
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                        {priceListRates.length > 0 ? priceListRates.map((item, index) => (
                                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                        )) : ''}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate</TableCell>

                                                        {priceListRates ? priceListRates.map((item, index) => (
                                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <input
                                                                    type="number"
                                                                    value={item.rate || ""}
                                                                    onChange={(e) => handleExtraChange(index, e.target.value)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                        )) : ''}
                                                    </TableRow>


                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>}


                                <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <Button variant="contained" color="primary" onClick={handleAdd}>Add</Button>
                                    <Button variant="contained" color="primary" onClick={handleRemoveSelected}>Delete</Button>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    {formArray.length > 0 &&
                                        <TableContainer
                                            style={{
                                                marginLeft: isDesktop ? '40%' : '0%',

                                            }}
                                        >
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Select.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>View</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {formArray.length > 0
                                                        ? formArray.map((form, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows.has(index)}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(form)} />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                        : ''}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }
                                </Grid>
                                {formArray?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default QuotationEntry;